/***************************************************
██╗    ██╗██╗██████╗ ██╗ ██████╗ ██████╗ ███╗   ███╗
██║    ██║██║██╔══██╗██║██╔════╝██╔═══██╗████╗ ████║
██║ █╗ ██║██║██████╔╝██║██║     ██║   ██║██╔████╔██║
██║███╗██║██║██╔══██╗██║██║     ██║   ██║██║╚██╔╝██║
╚███╔███╔╝██║██████╔╝██║╚██████╗╚██████╔╝██║ ╚═╝ ██║
 ╚══╝╚══╝ ╚═╝╚═════╝ ╚═╝ ╚═════╝ ╚═════╝ ╚═╝     ╚═╝
***************************************************/
let styles = [
    'background: black'
    , 'color: white'
    , 'display: block'

    , 'line-height: 40px'
    , 'text-align: center'
    , 'fontsize: 20px'
    , 'font-weight: lighter'
].join(';');

console.info('%c HANDMADED WITH ❤ BY WIBICOM ', styles);

/****************************************************
*****************************************************
*GESTION DU PUBLIC PATH DYNAMIC ;
***************************************************** 
****************************************************/
__webpack_public_path__ = base + '/assets/';
/****************************************************
*****************************************************
*IMPORT GLOBALS DEPENDENCIES FROM NODE MODULES;
*****************************************************
****************************************************/ 
window.isTouchDevice = false
if ("ontouchstart" in document.documentElement)
{
    window.isTouchDevice = true
    $('body').addClass('is-desktop');
}
else
{
    window.isTouchDevice = false;
    $('body').addClass('is-touch')
}
window.dev = false;
import $ from 'jquery';
window.$ = window.jQuery = $;
 
import fancybox from '@fancyapps/fancybox';
//import select2 from "select2/dist/js/select2.full.js";
//select2();

import './init.js';

